import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { type ReplyFilter, useReviewUIStore } from "../store/use-review-ui-store";

/**
 * Filter preset a link can hand to a reviews detail page through router
 * state, e.g. the "Awaiting your reply" triage link asking for the
 * unreplied set.
 */
export interface ReviewFilterIntent {
  replyFilter?: ReplyFilter;
}

/**
 * Seeds the shared review filter store on mount.
 *
 * The detail pages share one filter store, so each has to start from a
 * known state — otherwise a filter left behind on the other page (likely
 * the unreplied-only chip) silently empties the list and reads as a bug.
 * Resetting blindly used to wipe the filter an incoming link had just set,
 * because the link's click handler ran before the destination mounted.
 * Reading the preset from `location.state` removes that ordering problem:
 * the intent travels with the navigation instead of racing it.
 */
export function useReviewFilterIntent() {
  const { state } = useLocation();
  const replyFilter = (state as ReviewFilterIntent | null)?.replyFilter ?? "all";
  const setFilters = useReviewUIStore((s) => s.setFilters);

  useEffect(() => {
    setFilters({ starFilter: null, replyFilter });
  }, [setFilters, replyFilter]);
}
